import { NewOrderFunnel } from "@components/ProspectNew/NewOrderFunnel/NewOrderFunnel"
import {
  NewOrderFunnelProvider,
  useNewOrderFunnel,
} from "@components/ProspectNew/NewOrderFunnel/utils/useNewOrderFunnel"
import { useParams } from "react-router-dom"
import { UtilityInformation } from "@components/ProspectNew/NewOrderFunnel/UtilityInformation"
import { NewOrderForm } from "@components/ProspectNew/NewOrderFunnel/Forms/NewOrderForm"
import { ProspectTitle } from "@components/ProspectNew/ProspectTitle"

export const NewOrderPage = () => {
  const { prospect_guid } = useParams() as { prospect_guid: string }

  return (
    <NewOrderFunnelProvider prospect_guid={prospect_guid}>
      <NewOrderPageInner prospect_guid={prospect_guid} />
    </NewOrderFunnelProvider>
  )
}

const NewOrderPageInner = ({ prospect_guid }: { prospect_guid: string }) => {
  const { selectedMarket, selectedRevenueClassCode, selectedAddress, step } =
    useNewOrderFunnel()

  const newOrderFormVisible = step === "chooseOffer"
  const utilityInfoVisible = step === "chooseOffer" || step === "signUp"

  return (
    <div className="tw:flex tw:flex-col tw:gap-4 tw:p-4">
      <ProspectTitle prospect_guid={prospect_guid} />

      <div className="tw:flex tw:gap-6">
        <div className="tw:space-y-4">
          <div className={newOrderFormVisible ? "tw:block" : "tw:hidden"}>
            <NewOrderForm />
          </div>
          <div className={utilityInfoVisible ? "tw:block" : "tw:hidden"}>
            {selectedMarket && selectedRevenueClassCode ? (
              <UtilityInformation
                market_code={selectedMarket.market_code}
                revenue_class_code={selectedRevenueClassCode}
                zip_code={selectedAddress?.zip || ""}
              />
            ) : null}
          </div>
        </div>

        <div className="tw:flex-1">
          <NewOrderFunnel />
        </div>
      </div>
    </div>
  )
}
